import {ReactNode} from 'react';

import Auth from './Auth';
import {User} from '@ergeon/erg-auth';

import authService from '../../utils/auth';
import useStorageUserID from '../../hooks/useStorageUserID';
import useSentryUser from '../../hooks/useSentryUser';

import AuthContext from './AuthContext';

type AuthWrapperProps = {
  children: ReactNode;
};

const AuthWrapperContent = ({user, children}: {user: User; children: ReactNode}) => {
  // Store user ID in sessionStorage for GA4 tracking
  useStorageUserID(user);

  // Attach user info to Sentry events
  useSentryUser(user);

  return <AuthContext.Provider value={{user}}>{children}</AuthContext.Provider>;
};

const AuthWrapper = ({children}: AuthWrapperProps) => (
  <section
    data-testid="auth-wrapper"
  >
    <Auth authService={authService}>
      {(user: User) => <AuthWrapperContent user={user}>{children}</AuthWrapperContent>}
    </Auth>
  </section>
);

export default AuthWrapper;
